import type { DisciplineShow } from '../model/interfaces'

import { useCommonStore } from '@shared/model'
import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useDisciplineStore } from '../model/store'

interface DisciplineShowApiOptions {
  disciplineId: string | number
  /** Leave the layout loader alone: the caller shows its own (the discipline page loader). */
  silent?: boolean
  onStart?: () => void
  onSuccess?: (data: DisciplineShow) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useDisciplineShowApi = async (options: DisciplineShowApiOptions): Promise<DisciplineShow | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.disciplines.api.show', { discipline_id: options.disciplineId })

  const disciplineStore = useDisciplineStore()
  const commonStore = useCommonStore()

  const setLoading = (value: boolean): void => {
    if (!options.silent) commonStore.setLoading(value)
  }

  options.onStart?.()
  setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const discipline: DisciplineShow = data.data

    disciplineStore.setDiscipline(discipline)
    setLoading(false)

    options.onSuccess?.(discipline)

    return discipline
  } catch (err: unknown) {
    console.error(err)
    toast.error(getAxiosErrorMessage(err))
    setLoading(false)
    options.onError?.(err)

    return null
  } finally {
    options.onFinish?.()
  }
}